import { createSlice } from "@reduxjs/toolkit";
import {
  fetchSideBarAsanas,
  fetchAsanaBySlug, // ✅ renamed from fetchAsanaById
} from "../Action/SidebarAsanaAction";

const SideBarAsanaSlice = createSlice({
  name: "sideBarAsana",
  initialState: {
    sideAsanas: [],
    selectedAsana: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSideBarAsanas.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSideBarAsanas.fulfilled, (state, action) => {
        state.loading = false;
        state.sideAsanas = action.payload;
      })
      .addCase(fetchSideBarAsanas.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Something went wrong";;
      })

      // ✅ renamed from fetchAsanaById → fetchAsanaBySlug
      .addCase(fetchAsanaBySlug.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAsanaBySlug.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedAsana = action.payload;
      })
      .addCase(fetchAsanaBySlug.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Something went wrong";;
      });
  },
});

export default SideBarAsanaSlice.reducer;